import { render, staticRenderFns } from "./DataSharingNotificationCard.vue?vue&type=template&id=584fd67e"
import script from "./DataSharingNotificationCard.vue?vue&type=script&lang=js"
export * from "./DataSharingNotificationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports